module.exports = __webpack_public_path__ + "static/img/Ambrosio.80a6d7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ambrosio.jpg
// module id = UieX
// module chunks = 0